import { combineReducers } from "redux";
import selection from "./selection.js";
import banner from "./banner.js";
import pages from "./pages.js";
import token from "./token.js";
import isLogin from "./isLogin.js";
import memberId from "./memberId.js";
import mobile from "./mobile.js";
import stockIndex from "./stockIndex.js";
import {
    subAccount,
    subAccounts,
    subAccountMoney as accountMoney
} from "./trade.js";

const rootReducer = combineReducers({
    selection,
    banner,
    pages,
    isLogin,
    token,
    memberId,
    mobile,
    subAccounts,
    subAccount,
    stockIndex,
    accountMoney
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js


// WEBPACK FOOTER //
// ./src/reducers/index.js